import { createHistory } from 'history';

if (!window.graylogHistory) {
  window.graylogHistory = createHistory();
}

export default window.graylogHistory;



// WEBPACK FOOTER //
// ./src/util/History.js